import React, { useEffect, useState } from 'react';
import { FaCalendarAlt, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const DateRangePicker = ({
  setSelectedStartDate,
  setSelectedEndDate
}: any) => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [isStartCalendarOpen, setIsStartCalendarOpen] = useState(false);
  const [isEndCalendarOpen, setIsEndCalendarOpen] = useState(false);

  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const getDaysInMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
  };

  const renderCalendar = (date, setDate, isOpen, setIsOpen) => {
    const daysInMonth = getDaysInMonth(date);
    const firstDayOfMonth = getFirstDayOfMonth(date);
    const days = [];

    for (let i = 0; i < firstDayOfMonth; i++) {
      days.push(<div key={`empty-${i}`} className="h-8 w-8"></div>);
    }

    for (let i = 1; i <= daysInMonth; i++) {
      const currentDate = new Date(date.getFullYear(), date.getMonth(), i);
      const isSelected = currentDate.toDateString() === date.toDateString();
      days.push(
        <button
          key={i}
          onClick={() => {
            setDate(currentDate);
            setIsOpen(false);
            if (setDate === setStartDate) {
              setSelectedStartDate(currentDate);
            } else if (setDate === setEndDate) {
              setSelectedEndDate(currentDate);
            }
          }}
          className={`h-8 w-8 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 ${isSelected ? 'bg-blue-500 text-white' : 'hover:bg-gray-200'}`}
          aria-label={`Select ${currentDate.toDateString()}`}
        >
          {i}
        </button>
      );
    }

    // useEffect(() => {
    //   console.log('startDate in date-picker', startDate)
    // }, [startDate]);

    // useEffect(() => {
    //   console.log('endDate in date-picker', endDate)
    // }, [endDate]);
    

    return (
      <div className="absolute z-[2147483640] mt-1 w-64 rounded-lg bg-white shadow-lg">
        <div className="flex items-center justify-between p-2">
          <button
            // onClick={() => {setDate(new Date(date.getFullYear(), date.getMonth() - 1, 1)), setSelectedStartDate(new Date(date.getFullYear(), date.getMonth() - 1, 1))}}
            onClick={() => {
              const newDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
              setDate(newDate);
              if (setDate === setStartDate) {
                setSelectedStartDate(newDate);
              } else if (setDate === setEndDate) {
                setSelectedEndDate(newDate);
              }
            }}
            className="p-1 hover:bg-gray-200 rounded-full"
            aria-label="Previous month"
          >
            <FaChevronLeft />
          </button>
          <div>{monthNames[date.getMonth()]} {date.getFullYear()}</div>
          <button
            // onClick={() => {setDate(new Date(date.getFullYear(), date.getMonth() + 1, 1)), setSelectedEndDate(new Date(date.getFullYear(), date.getMonth() + 1, 1))}}
            onClick={() => {
              const newDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);
              setDate(newDate);
              if (setDate === setStartDate) {
                setSelectedStartDate(newDate);
              } else if (setDate === setEndDate) {
                setSelectedEndDate(newDate);
              }
            }}
            className="p-1 hover:bg-gray-200 rounded-full"
            aria-label="Next month"
          >
            <FaChevronRight />
          </button>
        </div>
        <div className="grid grid-cols-7 gap-1 p-2">
          {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map(day => (
            <div key={day} className="text-center text-xs font-semibold">{day}</div>
          ))}
          {days}
        </div>
      </div>
    );
  };

  const applyPreset = (preset) => {
    const today = new Date();
    let newStartDate, newEndDate;

    switch (preset) {
      case 'last7Days':
        newEndDate = today;
        newStartDate = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
        break;
      case 'thisMonth':
        newStartDate = new Date(today.getFullYear(), today.getMonth(), 1);
        newEndDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;
      default:
        return;
    }

    setStartDate(newStartDate);
    setEndDate(newEndDate);
  };

  return (
    <div className="p-4 max-w-4xl mx-auto bg-gray-100 rounded-lg shadow-md">
      <div className="flex flex-col md:flex-row justify-between space-y-4 md:space-y-0 md:space-x-4">
        <div className="w-full md:w-1/2">
          <label htmlFor="startDate" className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
          <div className="relative">
            <input
              type="text"
              id="startDate"
              value={startDate.toDateString()}
              readOnly
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              onClick={() => setIsStartCalendarOpen(!isStartCalendarOpen)}
            />
            <FaCalendarAlt className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            {isStartCalendarOpen && renderCalendar(startDate, setStartDate, isStartCalendarOpen, setIsStartCalendarOpen)}
          </div>
        </div>
        <div className="w-full md:w-1/2">
          <label htmlFor="endDate" className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
          <div className="relative">
            <input
              type="text"
              id="endDate"
              value={endDate.toDateString()}
              readOnly
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              onClick={() => setIsEndCalendarOpen(!isEndCalendarOpen)}
            />
            <FaCalendarAlt className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            {isEndCalendarOpen && renderCalendar(endDate, setEndDate, isEndCalendarOpen, setIsEndCalendarOpen)}
          </div>
        </div>
      </div>      
    </div>
  );
};

export default DateRangePicker;